Jelly.Actions.Update_Check_In = function(Parameters){

	// Normalize NaN etc to 0
	var Progress = parseInt($('.Checked_In_Progress').html());
	if (!Progress)
		Progress = 0;

	// TODO - Scope by namespace
	if (Parameters.Count_Checks) {
		var Total = 0;
		var Progress = 0;
		$.each(Friends_UI.entries.$items, function(item_index, $item){
			if ($item.hasClass("Values")){
				Total += $item.find("input").length;
				Progress += $item.find("input:checked").length;
			}
		});
		$('.Checked_In_Progress').html(Progress)
		$('.Checked_In_Total').html(Total);
	}

	else if (Parameters.Increment) {
		$('.Checked_In_Progress').html(Progress + 1)
	}
	else if (Parameters.Decrement) {
		if (Progress > 0)
			$('.Checked_In_Progress').html(Progress - 1)
	}

	else {
		if (Parameters.Progress){
			$('.Checked_In_Progress').html(Parameters.Progress);
		}
		if (Parameters.Total) {
			$('.Checked_In_Total').html(Parameters.Total);
		}
	}

	// Show / hide based on 0
	if (parseInt($('.Checked_In_Progress').html())) {
		$('.Checked_In .Hide_On_Zero').removeClass('iOS_Safari_Bug_Hidden');
	}
	else {
		$('.Checked_In .Hide_On_Zero').addClass('iOS_Safari_Bug_Hidden');
	}
};